import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { ThemeProvider } from "@material-tailwind/react";
import initAxiosInterceptors from "configs/axios";
import { store } from "store";
import { StyleSheetManager } from "styled-components";

import App from "./App";

import "./index.css";
initAxiosInterceptors();

const rootElement = document.getElementById("root");
const app = (
  <Provider store={store}>
    <ThemeProvider>
      <StyleSheetManager shouldForwardProp={(prop) => !prop.startsWith("$")}>
        <App />
      </StyleSheetManager>
    </ThemeProvider>
  </Provider>
);

// Public pages are prerendered at build time (see scripts/prerender.js) and arrive with
// real markup already in #root - hydrate onto it instead of wiping and re-rendering.
// Every other route still gets today's plain client render.
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  ReactDOM.createRoot(rootElement).render(app);
}
